import axios from 'axios'

export default axios.create({
    baseURL: 'https://api.lensadvisors.com/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    }
})